'use strict'

import escape from 'escape-html'
import formatPhoneNumber from '../../utils/formatPhoneNumber'
import adjustFontSizeToFit from '../../utils/adjustFontSizeToFit'
import adjustInfoVertical from '../../utils/adjustInfoVertical'


export class EditControl {
  constructor(element, svg) {
    this.$control = document.createElement('div')
    this.$control.classList.add('si_controls__control')
    this.$control.classList.add('si_control')
    this.$control.classList.add('si_control--text')

    const $label = document.createElement('label')
    $label.classList.add(`si_control__label`)
    if(document.documentElement.lang == 'en'){
      $label.innerHTML = 'Text'
    }else{
      $label.innerHTML = 'Texte'
    }


    this.$input = document.createElement('input')
    this.$input.classList.add('si_control__input')
    this.$input.classList.add('si_input')
    this.$input.classList.add('si_input--text')
    this.$input.setAttribute('type', 'text')

    this.prefix = element.attr('si:has-prefix') ? escape(element.attr('si:has-prefix')) : ''
    this.phoneFormat = element.attr('si:phone-format') ? escape(element.attr('si:phone-format')) : false
    this.phonePrefix = element.attr('si:phone-prefix') ? escape(element.attr('si:phone-prefix')) : ''

    this.hasBindic = element.attr('si:indic') ? true : false
    //
    this.bisElement = element.attr('si:bis') ? true : false
    
    
    if(this.bisElement){
      this.bisName = escape(element.attr('si:bis'));
      var bisElem = svg.select(this.bisName+' text');
    }
    if (this.hasBindic) {
      this.whichIndic = escape(element.attr('si:whichindic'))
      var bindic = svg.select('#'+this.whichIndic+' text');
      var bindicContent = bindic.node;
      this.origValue = escape(bindicContent.innerHTML+ this.phonePrefix +element.node.innerHTML)
      if(this.bisElement){
        var bincdicBis = svg.select('#'+this.whichIndic+'bis text');
        var bindicContentBis = bincdicBis.node;
      }
    }else{
      this.origValue = escape(element.node.innerHTML)
    }
    this.setValue(this.origValue)
    
    
    this.$input.addEventListener('input', (e) => {
      if (this.phoneFormat) {


        this.isInternational = element.attr('si:has-national-prefix') ? escape(element.attr('si:has-national-prefix')) : false

        if (this.hasBindic) {
          const num = this.prefix + formatPhoneNumber(escape(e.target.value), this.phoneFormat, this.phonePrefix, element.attr('has-national-prefix') == 'true', this.hasBindic)
          if (this.prefix) {
            element.node.innerHTML = num.substr(5, 10);
            bindicContent.innerHTML = num.substr(0, 4);
            adjustFontSizeToFit(bindic, true);
          } else {
            element.node.innerHTML = num.substr(4, 10);
            if(bindic.attr('si:numDeco') == "("){
              bindicContent.innerHTML = "(";
              bindicContent.innerHTML += num.substr(0, 3);
              bindicContent.innerHTML += ")";
            }else{
              bindicContent.innerHTML = num.substr(0, 3);
            }
            
            adjustFontSizeToFit(bindic, true);
          }
          //bis indic
          if(this.bisElement){
             bisElem.node.innerHTML = element.node.innerHTML;
             bindicContentBis.innerHTML = bindicContent.innerHTML;
             adjustFontSizeToFit(bincdicBis, true);
          }
        } else {
          element.node.innerHTML = this.prefix + formatPhoneNumber(escape(e.target.value), this.phoneFormat, this.phonePrefix, element.attr('has-national-prefix') == 'true', this.hasBindic)
           if(this.bisElement){
             bisElem.node.innerHTML = element.node.innerHTML;
           }
        }

      } else {
        element.node.innerHTML = this.prefix + escape(e.target.value)
    
        adjustFontSizeToFit(element, false)
        adjustInfoVertical(element, false)
        
        // bis element for texte
        if(this.bisElement){
          bisElem.node.innerHTML = this.prefix + escape(e.target.value)
          adjustFontSizeToFit(bisElem, false)
          //console.log(this.bisName);
          adjustInfoVertical(bisElem, true)
        }
      }

      
      element.node.dispatchEvent(new Event('fontSizeChange'))
    })

    /*element.node.addEventListener('click', () => {
      this.$input.focus()
      this.$input.select()
    })*/

    this.$control.appendChild($label)
    $label.appendChild(this.$input)

    this.reset = this.reset.bind(this, element)

    return this
  }

  getElement() {
    return this.$control
  }

  setValue(value) {
    this.$input.value = value
    return this
  }

  getValue() {
    return this.$input.value
  }

  reset(element) {
    this.setValue(this.origValue)
  }
}
